import React from 'react';
import AnalitikPage from '../pages/AnalitikPage';

const DashboardAnalitik = () => {
  return (
    <div style={{ margin: '-1.5rem -2rem' }}>
      <div style={{ padding: '1.5rem 2rem' }}>
        <AnalitikPage />
      </div>
    </div>
  );
};

export default DashboardAnalitik;
